module.exports = __webpack_public_path__ + "d1b0324ac57ee051a8bf45b1c53cb601.jpg";